import { classifyTrialEndUsage, TrialEndUsageClass } from './classify-trial-end-usage';

export type ComplimentaryTrialEndedEligibilityInput = {
  isSettled: boolean;
  isCohortEnabled: boolean;
  isTrialEndEnabled: boolean;
  isAppleCompliantBuild: boolean;
  isExcluded: boolean;
  consumed: string | null | undefined;
  displayLimit: string | null | undefined;
};

export type ComplimentaryTrialEndedUsageClass =
  | TrialEndUsageClass.High
  | TrialEndUsageClass.Moderate;

export const getComplimentaryTrialEndedUsageClass = ({
  isSettled,
  isCohortEnabled,
  isTrialEndEnabled,
  isAppleCompliantBuild,
  isExcluded,
  consumed,
  displayLimit,
}: ComplimentaryTrialEndedEligibilityInput): ComplimentaryTrialEndedUsageClass | null => {
  if (
    !isSettled ||
    !isCohortEnabled ||
    !isTrialEndEnabled ||
    isAppleCompliantBuild ||
    isExcluded
  ) {
    return null;
  }
  if (consumed == null || displayLimit == null) return null;

  const usageClass = classifyTrialEndUsage({ consumed, displayLimit });
  return usageClass === TrialEndUsageClass.Low ? null : usageClass;
};
